import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import PluginRouterPush from './plugins/goTo';
import PluginAPI from './plugins/serverAPI';
import 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Vuetify from 'vuetify';
import vueMoment from 'vue-moment';
import moment from 'moment';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { library as faLibrary } from '@fortawesome/fontawesome-svg-core';
import { faDownload, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

router.beforeEach((to, from, next) => {
  // 직접적으로 path 값 변경 시 state의 국가명과 맞지 않을 때
  if (to.name.substr(0, 3) == 'en-' && store.getters.lan !== 'en') {
    store.dispatch('getLang', 'en');
  } else if (to.name.substr(0, 3) !== 'en-' && store.getters.lan == 'en') {
    store.dispatch('getLang', 'kr');
  }

  // 관리자 로그인 상태로 login 접근
  if (
    (store.getters.userAccTokenExp ||
      store.getters.userAccToken ||
      store.getters.userAccTokenExp > +new Date()) &&
    to.name == 'login'
  ) {
    next({ name: 'home' });
    return;
  }

  // 관리자 페이지 접근
  if (to.path.substr(0, 6) == '/admin') {
    if (
      !store.getters.userAccTokenExp ||
      !store.getters.userAccToken ||
      store.getters.userAccTokenExp < +new Date()
    ) {
      // 유효하지 않은 토큰으로 admin_section 접근할 때 로그인으로 보냄
      next({ name: 'login' });
      return;
    } else {
      next();
      return;
    }
  } else {
    next();
    return;
  }
});
faLibrary.add(faDownload, faCircleNotch);
Vue.config.productionTip = false;
Vue.use(router);
Vue.use(PluginRouterPush);
Vue.use(PluginAPI);
Vue.use(Vuetify);
moment.locale('ko');
Vue.use(vueMoment, { moment });
Vue.component('font-awesome-icon', FontAwesomeIcon);
Chart.plugins.unregister(ChartDataLabels);

new Vue({
  mounted() {
    AOS.init({
      easing: 'ease-in-sine',
      duration: 1200,
    });
  },
  vuetify: new Vuetify(),
  el: '#app',
  router,
  store,
  render: h => h(App),
});
